import React, { useEffect } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import HeroSectionImageSlider from "../Components/HeroSectionImageSlider";
import AccountDetails from "../Components/AccountDetails";
import DonationForm from "../Components/PitruPakshaDonationForm";
import pitrupaksha1 from "../assets/pitrupaksha1.jpeg";
import pitrupaksha2 from "../assets/pitrupaksha2.jpeg";
import pitrupaksha3 from "../assets/pitrupaksha3.jpeg";
import pitrupaksha4 from "../assets/pitrupaksha4.jpeg";

const Pitrupaksha2026 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <HeroSectionImageSlider
        slides={[
          { img: pitrupaksha1 },
          { img: pitrupaksha2 },
          { img: pitrupaksha3 },
          { img: pitrupaksha4 },
        ]}
      />

      {/* Section 1 */}
      <section className="w-full bg-gradient-to-b from-amber-50/40 via-white to-white py-10 sm:py-14 px-4 sm:px-8 md:px-12 lg:px-20">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="font-dm-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-red tracking-tight leading-tight mb-3 sm:mb-4">
            Pitru Paksha Seva 2026 | ISKCON Vijayawada
          </h1>
          <h2 className="font-dm-serif text-lg sm:text-xl md:text-2xl text-darkred/90 font-medium italic max-w-4xl mx-auto leading-relaxed mb-6">
            – Offer Shraddha Seva to your ancestors and Receive the boundless
            mercy of Lord Krishna
          </h2>

          <div className="flex items-center justify-center gap-3 my-6">
            <span className="h-0.5 w-12 sm:w-16 bg-gradient-to-r from-transparent to-orange rounded-full" />
            <span className="text-orange text-lg">✦</span>
            <span className="h-0.5 w-12 sm:w-16 bg-gradient-to-l from-transparent to-orange rounded-full" />
          </div>

          <div className="text-gray-700 text-base sm:text-lg leading-relaxed space-y-5 max-w-4xl mx-auto text-left sm:text-justify font-normal">
            <p>
              <strong className="text-gray-900 font-semibold">
                Pitru Paksha
              </strong>{" "}
              is a sacred sixteen-day period in the Vedic calendar, dedicated to
              remembering and honouring our departed ancestors. During this
              time, devotees perform{" "}
              <strong className="text-gray-900 font-semibold">
                Shraddha Seva
              </strong>{" "}
              and offer charity to bring peace to the souls of their
              forefathers. The scriptures explain that such offerings help
              ancestors progress to higher destinations and shower blessings of{" "}
              <strong className="text-gray-900 font-semibold">
                health, prosperity, and harmony
              </strong>{" "}
              upon their families.
            </p>
            <p>
              At{" "}
              <strong className="text-gray-900 font-semibold">
                ISKCON Vijayawada
              </strong>
              , we are providing devotees the opportunity to perform special
              Sevas during Pitru Paksha. These sevas, when performed with
              devotion, not only benefit your ancestors but also please{" "}
              <strong className="text-gray-900 font-semibold">
                Sri Sri Radha Shyam Sundar
              </strong>
              .
            </p>
          </div>
        </div>
      </section>
      {/* Form */}
      <DonationForm />
      <AccountDetails />
      {/* Notes */}
      <div className="mx-4 md:mx-12 my-6 p-5 sm:p-6 border border-red/40 bg-amber-50/50 rounded-2xl shadow-sm max-w-7xl lg:mx-auto">
        <div className="flex items-start">
          <div className="flex-1">
            <h3 className="text-lg sm:text-xl font-semibold text-red mb-2 font-dm-serif">
              Gentle Request!
            </h3>
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base m-0">
              While doing Paytm/UPI App Payments or Bank (NEFT/RTGS) please send
              us a screenshot along with complete address and PAN details on our
              contact details: WhatsApp{" "}
              <a
                href="https://wa.me/919955685568"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-semibold underline"
              >
                +91-9955685568
              </a>{" "}
              Email:{" "}
              <a
                href="mailto:seva@iskconvijayawada.org"
                className="text-blue-600 hover:text-blue-800 font-semibold underline"
              >
                seva@iskconvijayawada.org
              </a>{" "}
              You may also call on the above number for other queries.
            </p>
          </div>
        </div>
      </div>
      {/* Details of Seva */}
      <div className="w-full py-8 sm:py-14 px-4 sm:px-8 md:px-12 lg:px-20 bg-white">
        <div className="max-w-5xl mx-auto space-y-12 sm:space-y-16">
          {/* Section: Why Offer Seva During Pitru Paksha? */}
          <div>
            <h2 className="font-dm-serif text-2xl sm:text-3xl md:text-4xl font-bold text-red text-center mb-6 sm:mb-8 tracking-tight">
              Why Offer Seva During Pitru Paksha?
            </h2>

            <ul className="space-y-3 sm:space-y-4 max-w-4xl mx-auto">
              {[
                "It uplifts the souls of departed ancestors.",
                "It brings health, peace, and prosperity to the family.",
                "It is recommended in the Vedic scriptures to perform charity, Annadana, and Gau Seva during this sacred period.",
                "By offering seva through ISKCON Vijayawada, you also receive the immense blessings of Sri Sri Radha Shyamsundar and Sri Jagannath Baladeva Subhadra.",
              ].map((text, idx) => (
                <li
                  key={idx}
                  className="group relative flex items-start gap-3.5 sm:gap-4 bg-amber-50/40 hover:bg-amber-50/80 border border-amber-100/80 rounded-xl p-4 sm:p-5 transition-all duration-200 hover:translate-x-1.5 hover:shadow-md"
                >
                  <span className="text-orange text-lg sm:text-xl font-bold mt-0.5 flex-shrink-0 transition-transform duration-200 group-hover:scale-110">
                    ✦
                  </span>
                  <span className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    {text}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Section: Seva Opportunities */}
          <div>
            <h2 className="font-dm-serif text-2xl sm:text-3xl md:text-4xl font-bold text-red text-center mb-6 sm:mb-8 tracking-tight">
              Seva Opportunities
            </h2>

            <div className="space-y-5 sm:space-y-6  mx-auto">
              {/* 1. Sadhu Bhojana Seva */}
              <div className="bg-[#fdf6f0] border-l-4 sm:border-l-[5px] border-orange rounded-xl px-4 py-3 sm:p-7 shadow-sm hover:shadow-lg transition-all duration-200 hover:translate-x-1.5">
                <h3 className="text-xl sm:text-2xl font-bold text-red mb-2.5 font-dm-serif">
                  1. Sadhu Bhojana Seva
                </h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Feeding Vaishnavas, sadhus, and devotees with sanctified
                  prasadam is considered one of the greatest forms of charity in
                  the scriptures. By sponsoring Sadhu Bhojana Seva during Pitru
                  Paksha, you not only honour your ancestors but also invite
                  divine blessings of spiritual progress, peace, and prosperity
                  for your family.
                </p>
              </div>

              {/* 2. Gau Poshana Seva */}
              <div className="bg-[#fdf6f0] border-l-4 sm:border-l-[5px] border-orange rounded-xl px-4 py-3 sm:p-7 shadow-sm hover:shadow-lg transition-all duration-200 hover:translate-x-1.5">
                <h3 className="text-xl sm:text-2xl font-bold text-red mb-2.5 font-dm-serif">
                  2. Gau Poshana Seva
                </h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  The cow (Gomata) holds a very special place in Vedic culture
                  and is most dear to Lord Krishna. Supporting Gau Seva ensures
                  the care, protection, and feeding of cows at the temple
                  goshala. Offering this seva during Pitru Paksha pleases both
                  the Lord and your departed forefathers, bestowing eternal
                  merit upon your family.
                </p>
              </div>

              {/* 3. Annadana Seva */}
              <div className="bg-[#fdf6f0] border-l-4 sm:border-l-[5px] border-orange rounded-xl px-4 py-3 sm:p-7 shadow-sm hover:shadow-lg transition-all duration-200 hover:translate-x-1.5">
                <h3 className="text-xl sm:text-2xl font-bold text-red mb-2.5 font-dm-serif">
                  3. Annadana Seva
                </h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Annadana – the offering of food – is described in the
                  scriptures as the highest form of charity. By sponsoring
                  Annadana Seva during Pitru Paksha, you help distribute
                  sanctified food to devotees, guests, and the needy, bringing
                  satisfaction to your ancestors and receiving the mercy of Lord
                  Krishna in return.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Pitrupaksha2026;
